import React from 'react'
import * as ReactRouterDom from 'react-router-dom';
import { IOWidget, mk_widget, Fun, Unit, Widget, Options } from '../main';
import { option, Action } from '../widget';
import queryString from 'query-string-es5'


export interface Route<R> { title?:string, path?:string, paramsToRoute:Fun<any, R> }
export interface Routes<R> extends Array<Route<R>> {}

export const route = function<P,R>(path:string, paramsToRoute:Fun<P,R>) : Route<R> {
  return { path:path, paramsToRoute:paramsToRoute }
}

export const notFoundRouteCase = function<R>(makeRoute:Fun<Unit,R>) : Route<R> {
  return { paramsToRoute:makeRoute }
}

export const routerSwitch = function<R>(options?:Options) {
  return (routes:Routes<R>) : Widget<R> => mk_widget({ run:onDone =>
    React.createElement<RouteForwarderProps<R>>(RouteForwarder, { routes, onDone, options, key: option("key", options) })
  })
}

export const browserRouter = function<O>(options?:Options) {
  return (component:Widget<O>) : Widget<O> => mk_widget({ run:onDone =>
    <ReactRouterDom.BrowserRouter key={option("key", options)}>
      {
        component.run(onDone)
      }
    </ReactRouterDom.BrowserRouter>
  })
}


interface RouteForwarderProps<R> {
  routes:Routes<R>
  onDone:Fun<R,void>
  options?:Options
}

interface RouteForwarderState<R> {
  readonly currentRoute?:Route<R>
  readonly currentRouteParams?:ReactRouterDom.RouteComponentProps<any>
  readonly callback?:() => void
}

class RouteForwarder<R> extends React.Component<RouteForwarderProps<R>, RouteForwarderState<R>> {
  constructor(props:RouteForwarderProps<R>, context:any) {
    super(props, context)

    this.state = {}
  }

  // shouldComponentUpdate(nextProps:RouteForwarderProps<R>, nextState:RouteForwarderState<R>) {
  //   return nextState.callback != undefined
  // }

  render() {
    return <ReactRouterDom.Switch key={option("key", this.props.options)}>
      {
        this.props.routes.map(currentRoute =>
          <ReactRouterDom.Route key={`route-${currentRoute.path}`} exact path={currentRoute.path}
            component={(currentRouteParams:ReactRouterDom.RouteComponentProps<any>) => {
                // console.log("instantiating component at route", currentRouteParams.location.pathname)
                const s = this.state
                let nextState:RouteForwarderState<R> = ({...s,
                  currentRoute:currentRoute,
                  currentRouteParams:currentRouteParams,
                  callback:undefined
                })

                if ((this.state.currentRoute && this.state.currentRouteParams &&
                  (this.state.currentRouteParams.location.pathname != currentRouteParams.location.pathname ||
                   this.state.currentRouteParams.location.search != currentRouteParams.location.search)) ||
                  !this.state.currentRoute || !this.state.currentRouteParams) {
                  // console.log("setting up a callback, with", currentRoute.path, this.state, currentRouteParams.location.pathname)
                  nextState = {...nextState, callback:() => this.props.onDone(
                    currentRoute.paramsToRoute({
                      ...currentRouteParams.match.params,
                      ...queryString.parse(currentRouteParams.location.search)}))
                    }
                  }

                if (nextState.callback != undefined) {
                  this.setState(nextState, () => {
                    // console.log("state has been updated", currentRouteParams.location.pathname)
                    if (this.state.callback) {
                      // console.log("proceeding with callback", currentRouteParams.location.pathname)

                      const callback = this.state.callback
                      return this.setState(s => ({...s, callback:undefined}), () => {
                        if (currentRoute.title != undefined) document.title = currentRoute.title
                        callback()
                      })
                    }
                    // console.log("there is no callback", currentRouteParams.location.pathname)
                  })
                }
                return null
              }
            } />
        )
      }
    </ReactRouterDom.Switch>
  }
}
